import { FuelTypography } from '@frete.com/fuel-react';
import illustrationEmptyStateTrading from 'assets/illustrations/empty-state-trading.svg';
import illustrationEmptyStateFilter from 'assets/illustrations/no-result.svg';
import styled from 'styled-components';

export const FilterEmptyStateImage = styled.img.attrs({
  src: String(illustrationEmptyStateFilter),
})`
  width: 225px;
  height: 172px;
  margin-bottom: ${({ theme }) => theme.spacing.km12};
`;

export const EmptyStateTradingImage = styled.img.attrs({
  src: String(illustrationEmptyStateTrading),
})`
  width: 212px;
  height: 137px;
  margin-bottom: 90px;
`;

export const TitleCustom = styled(FuelTypography)`
  margin-bottom: ${({ theme }) => theme.spacing.km4};
`;

export const SubCustom = styled(FuelTypography)`
  margin-bottom: ${({ theme }) => theme.spacing.km8};
  letter-spacing: -0.03em;
`;
